import Session from 'api/storage/session';
import { maskEmail } from './email';

export const getMaskedEmail = (): string => {
  const loggedUserEmail = Session.decodeToken()?.email;
  if (!loggedUserEmail) return '';
  return maskEmail(loggedUserEmail);
};
